import IncidentService from '@api/IncidentService';
import ClinicalLogRecord from '@components/SubmissionTabs/ClinicalLogRecord';
import ClinicalReviewForm from '@components/SubmissionTabs/ClinicalReviewForm';
import ReportHeader from '@components/SubmissionTabs/ReportHeader';
import SubmissionTabs from '@components/SubmissionTabs/SubmissionTabs';
import routes from '@constants/routes';
import { ExpertRole } from '@declarations/common/enums/ExpertRole';
import { UserType } from '@declarations/common/enums/UserType';
import { ReportTypeEnum } from '@declarations/common/reportType';
import useApi from '@hooks/useApi';
import { UserSelectors } from '@store/slices/user';
import { memo, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

function IncidentClinicalReviewTab() {
  const [searchParams] = useSearchParams();
  const user = useSelector(UserSelectors.user);
  const logRecordRef = useRef<{ refresh(): void }>(null);

  const { data, isLoading, fetch } = useApi({
    method: IncidentService.getById,
    initialData: {} as any,
  });

  useEffect(() => {
    fetch(Number(searchParams.get('id')));
  }, []);

  const handleSave = () => {
    logRecordRef.current?.refresh();
  }
  
  const showForm = user.type === UserType.SuperAdmin || user.expertRole === ExpertRole.ClinicalReviewer || user.expertRole === ExpertRole.IntegratedReviewer;

  return (
    <>
      <SubmissionTabs active="clinical-review" prefix={routes.incidentReportForm} />
      <ReportHeader
        name="Incident"
        createdAt={data.createdAt}
        reportNumber={data.reportNumber}
        riskPoints={data.riskPoints}
        loading={isLoading}
      />
      {showForm && <ClinicalReviewForm reportType={ReportTypeEnum.Incident} onSave={handleSave} />}
      <ClinicalLogRecord reportType={ReportTypeEnum.Incident} ref={logRecordRef} />
    </>
  );
}

export default memo(IncidentClinicalReviewTab);
